import React from "react";
import Layout from "../../../Components/Layouts/Layout";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import { useQuery } from "react-query";
import { getApiData } from "../../../Services/apiMethods";

const HomeHeader = () => {
  const titleOrganizer = (title) => {
    let firstHeading = "";
    var finalTitle = "";
    var highlightedHeading = "";
    var lastHeading = "";
    title.map((item, index) => {
      if (index < 2) {
        firstHeading = firstHeading + item + " ";
      } else if (index === 2) {
        highlightedHeading = item + " ";
      } else {
        lastHeading = lastHeading + item + " ";
      }
    });
    finalTitle = (
      <h1 className="text-4xl md:text-5xl xl:text-6xl font-light mb-10">
        {firstHeading} <span className="text-brand">{highlightedHeading}</span>
        {lastHeading}
      </h1>
    );
    return finalTitle;
  };

  const getHomeHeaderData = () => {
    return getApiData("home/slider");
  };
  const { isLoading, data, isError, error } = useQuery(
    "home-header",
    getHomeHeaderData
  );

  if (isLoading) {
    return "Loading... PLease wait a moment.";
  }

  if (isError) {
    return error.message;
  }

  const sliders = data.data.sliders;

  return (
    <Swiper
      autoplay={{
        delay: 2500,
      }}
      loop={true}
      pagination
      navigation={true}
      modules={[Autoplay, Navigation]}
      className="mySwiper"
    >
      {sliders.map((header) => (
        <SwiperSlide key={header._id}>
          <section
            className="bg-cover bg-no-repeat"
            style={{
              backgroundImage: `url(${process.env.REACT_APP_IMAGE_BASE_URL}/${header.image}`,
            }}
          >
            <Layout>
              <div className="h-screen flex justify-center items-center">
                <div className="text-center mb-16 lg:mb-52 flex flex-col justify-center items-center md:w-2/3">
                  {titleOrganizer(header.title.split(" "))}
                  <p className="md:text-xl font-light sm:px-6 md:px-8 xl:px-16">
                    {header.description}
                  </p>
                  <hr className="w-1/6 mx-auto mt-5 border border-brand" />
                </div>
              </div>
            </Layout>
          </section>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HomeHeader;
